import DicasOtimizacao from '../DicasOtimizacao/index';

function AnalisesTextuais() {
  return <DicasOtimizacao layout="mobile" />;
}

export default AnalisesTextuais;
